export default __webpack_public_path__ + "static/media/doctor2.64775f7b.jpg";